import { useState } from 'react';
import TranslationText from '@Components/Utilities/TranslationText';
import Button from '@mui/material/Button';
import translator from '@Components/Utilities/Translator';
import { INT32_MAX_VALUE }  from '@Components/Utilities/SandhillsConstants';

const BidHistoryTable = (props) => {
    const [maxBidValues, setMaxBidValues] = useState({});

    const getColumnClass = () => {
        var columnCount = 3;
        if (props.showMaxBids) {
            columnCount++;  
        }
        if (props.deleteBid) {
            columnCount++;
        }
        if (props.showEditMaxBids) {
            columnCount++;
        }

        return 'column' + columnCount.toString();
    };

    return (
        <div className='bid-history-table'>
            <h2>{props.tableTitle}</h2>
            <div className='row cf titles mobile-hide'>
                <div className={getColumnClass() + ' left'}>
                    <TranslationText tKey='sandhills.tradepubwebsite.mvc.bidder' />
                </div>
                {props.showMaxBids &&
                    <div className={getColumnClass() + ' left'}>
                        <TranslationText tKey='sandhills.tradepubwebsite.mvc.maxbid' />
                    </div>}
                <div className={getColumnClass() + ' left'}>
                    <TranslationText tKey='sandhills.bidamount' />
                </div>
                <div className={getColumnClass() + ' left'}>
                    <TranslationText tKey='sandhills.tradepubwebsite.mvc.biddatetime' />
                </div>
                {props.deleteBid &&
                    <div className={getColumnClass() + ' left'}></div>}
                {props.showEditMaxBids &&
                    <div className={getColumnClass() + ' left'}></div>}
            </div>

            {(props.bidHistory && props.bidHistory.length > 0) ?
                <>
                    {props.bidHistory.map((bid, index) =>
                        <div key={`${bid.BidderCentralUserAuthID}-${bid.BidDate}-${index}`} className={'row cf' + (bid.IsDeleted ? ' row-deleted-bid' : ' row-active-bid')}>
                            <div className={getColumnClass() + ' left'}>
                                {bid.BidderInfoLink ?
                                    <a href={bid.BidderInfoLink} target="_blank" aria-label={bid.BidderName + " (" + translator.translate('sandhills.opensinanewtab') + ")"}>
                                        {bid.BidderName}</a>
                                    :
                                    bid.BidderName}
                                <br />
                                {props.deleteBid ?
                                    bid.BidderNumber
                                    :
                                    bid.BidderLocation}
                            </div>
                            {props.showMaxBids &&
                                <div className={getColumnClass() + ' left'}>
                                    {bid.MaxBidAmount}
                                </div>}
                            <div className={getColumnClass() + ' left'}>
                                {bid.BidAmount}
                            </div>
                            <div className={getColumnClass() + ' left'}>
                                {bid.BidDate}
                            </div>
                            {props.deleteBid &&
                                <div className={getColumnClass() + ' left'}>
                                    {bid.IsDeleted ?
                                        <TranslationText tKey='sandhills.crm.dscrm.deleted' />
                                        :
                                        <Button className='delete-bid-btn' variant="contained" onClick={(e) => { props.deleteBid(bid); }}><TranslationText tKey='sandhills.delete' /></Button>}
                                </div>}
                            {props.showEditMaxBids &&
                                <div className={getColumnClass() + ' left edit-max-bid-column'}>
                                    <input type='number' aria-label='Max Bid' placeholder='Max Bid' min="1" max={INT32_MAX_VALUE}
                                        value={maxBidValues[bid.BidderCentralUserAuthID] || ''}
                                        onChange={(e) => {
                                            setMaxBidValues((currentValues) => ({
                                                ...currentValues,
                                                [bid.BidderCentralUserAuthID]: e.target.value
                                            }));
                                        }} />
                                    <Button className='save-bid-btn' variant="contained" onClick={(e) => {
                                        const maxBidValue = maxBidValues[bid.BidderCentralUserAuthID];
                                        props.saveMaxBid(bid, maxBidValue ? Number(maxBidValue) : null);
                                    }}><TranslationText tKey='sandhills.tradepubwebsite.mvc.save' /></Button>
                                </div>}
                        </div>
                    )}
                </>
                :
                <>
                    <p><TranslationText tKey='sandhills.tradepubwebsite.mvc.nobidsplaced' /></p>
                </>
            }
        </div>
    );
};
export default BidHistoryTable;